import { RouteProps } from './route';
import HomePage from '../pages/home/homePage';
import AboutPage from '../pages/about/aboutPage';
import AppLayout from '../layouts/appLayout/appLayout';
import PersonProfile from '../pages/personProfile/personProfile';
import { RolesAndCerts } from '../pages/personProfile/rolesAndCerts';
import { Registrations } from '../pages/personProfile/registrations';
import Officials from '../pages/officials/officials';
import InviteUser from '../pages/inviteUser/inviteUser';
import { EvaluationEditor } from '../pages/evaluation/evaluationEditor';
import { EvaluationsEvaluatorView } from '../pages/evaluation/evaluationsEvaluatorView';
import EvaluationTemplate from '../pages/evaluationTemplate/evaluationTemplate';
import EvaluationTemplatesView from '../pages/evaluationTemplate/evaluationTemplatesView';
import { OfficialDetails } from '../pages/officialDetails/officialDetails';
import { Evaluations as OfficialEvaluations } from '../pages/officialDetails/evaluations';
import { EvaluationsByOthers as OfficialEvaluationsByOthers } from '../pages/officialDetails/evaluationsByOthers';
import { Tournaments as OfficialTournaments } from '../pages/officialDetails/tournaments';
import { Registrations as OfficialRegistrations } from '../pages/officialDetails/registrations';
import { RolesAndCerts as OfficialRolesAndCerts } from '../pages/officialDetails/rolesAndCerts';
import { PersonRole } from '../models/eums/personRole';
import { MyTournaments } from '../pages/myTournaments/myTournaments';
import { TournamentCalendarView } from '../pages/tournamentCalendar/tournamentCalendar';
import { ViewTournamentDetails } from '../pages/tournamentDetails/viewTournamentDetails';
import { EditTournamentDetails } from '../pages/tournamentDetails/editTournamentDetails';
import { EvaluationsEvalueeView } from '../pages/evaluation/evaluationsEvalueeView';
import RulesPage from 'pages/about/rulesPage';
import MembersPage from 'pages/about/membersPage';
import ContactsAndInformation from 'pages/about/contactsAndInformation';

export const routes: Array<RouteProps> = [
  {
    exact: true,
    path: '/',
    Component: HomePage,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/about',
    Component: AboutPage,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/my-profile',
    Component: PersonProfile,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/roles-and-certs',
    Component: RolesAndCerts,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/contact-and-information',
    Component: ContactsAndInformation,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/registrations',
    Component: Registrations,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/rules',
    Component: RulesPage,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/members',
    Component: MembersPage,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/officials',
    Component: Officials,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/my-tournaments',
    Component: MyTournaments,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/tournament-calendar',
    Component: TournamentCalendarView,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/tournament-calendar/tournament/:tournamentId',
    Component: ViewTournamentDetails,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/tournament-calendar/edit-tournament/:tournamentId',
    Component: EditTournamentDetails,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/tournament-calendar/edit-tournament',
    Component: EditTournamentDetails,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/:personId',
    Component: OfficialDetails,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/evaluations/:personId',
    Component: OfficialEvaluations,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/evaluations-by-others/:personId',
    Component: OfficialEvaluationsByOthers,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/tournaments/:personId',
    Component: OfficialTournaments,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/registrations/:personId',
    Component: OfficialRegistrations,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/officials/official-details/roles-and-certs/:personId',
    Component: OfficialRolesAndCerts,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/admin/invite-user',
    Component: InviteUser,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/evaluation/create',
    Component: EvaluationEditor,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/evaluations-evaluator',
    Component: EvaluationsEvaluatorView,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/evaluations-evaluee',
    Component: EvaluationsEvalueeView,
    requireAuth: true,
    Layout: AppLayout,
  },
  {
    exact: true,
    path: '/evaluation-templates/create',
    Component: EvaluationTemplate,
    requireAuth: true,
    Layout: AppLayout,
    roles: [PersonRole.Admin],
  },
  {
    exact: true,
    path: '/evaluation-templates',
    Component: EvaluationTemplatesView,
    requireAuth: true,
    Layout: AppLayout,
  },
];
